import React from 'react';
import styled from 'styled-components';
import { maxWidth, spacing } from '../../styles';

export default styled.div`
  max-width: ${maxWidth};
  padding: ${spacing['3']};
  margin: 0 auto;
`;
